import script from "./OrderShipped.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderShipped.vue?vue&type=script&setup=true&lang=ts"

import "./OrderShipped.vue?vue&type=style&index=0&id=3a68628b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a68628b"]])

export default __exports__